<template>
  <div class="container">
    <div class="integral new-input-box">
      <div class="back-btn">
        <jd-button
          type="blue"
          :styleTextObj="{
            width: auto,
            height: '24px',
          }"
          @click="toGiftList"
          >返回</jd-button
        >
      </div>
      <jd-tip class="mt16">
        说明：该功能是将所有的积分兑换活动集中在一个小程序页面展示，C端用户可直观的看到可兑的活动
      </jd-tip>
      <div class="decor-content" v-if="!isHasSave">
        <jd-title type="bold" label="积分商城装修"></jd-title>
        <div class="content-form">
          <el-form :model="formSave" label-width="124px" required>
            <el-form-item label="活动背景图：">
              <div class="flex-style">
                <el-upload
                  style="display: flex; align-items: center"
                  action="/jd-hd-web/image/upload"
                  ref="upload"
                  :before-upload="beforeUpload"
                  :on-success="handleSuccess"
                  :show-file-list="false"
                  accept=".png, .jpg"
                >
                  <jd-button type="blue">自定义上传</jd-button>
                </el-upload>
                <jd-button
                  style="margin: 0 16px"
                  type="blueText"
                  @click="
                    formSave.awardImageUrl =
                      'https://yunqi-hd-public.tos-cn-beijing.volces.com/image/pointExchangeBg.png'
                  "
                  >重置</jd-button
                >
                <span class="size-style">
                  尺寸建议：750*602px；支持格式：jpg，png
                </span>
              </div>
            </el-form-item>
            <el-form-item label="兑换列表样式：">
              <el-radio
                v-model="formSave.listStyle"
                :label="1"
                @change="handleColor"
                >列表模式</el-radio
              >
              <el-radio
                v-model="formSave.listStyle"
                :label="2"
                @change="handleColor"
                >网格模式</el-radio
              >
            </el-form-item>
            <el-form-item label="是否显示库存：">
              <el-radio v-model="formSave.stockIsShow" :label="false"
                >不显示</el-radio
              >
              <el-radio v-model="formSave.stockIsShow" :label="true"
                >显示</el-radio
              >
            </el-form-item>
            <el-form-item label="是否显示面值：">
              <el-radio v-model="formSave.awardValueIsShow" :label="false"
                >不显示</el-radio
              >
              <el-radio v-model="formSave.awardValueIsShow" :label="true"
                >显示（开启后C端兑换列表页显示奖品价值）</el-radio
              >
            </el-form-item>
            <el-form-item label="是否显示倒计时：">
              <el-radio v-model="formSave.countdownIsShow" :label="false"
                >不显示</el-radio
              >
              <el-radio v-model="formSave.countdownIsShow" :label="true"
                >显示（开启后C端兑换列表页显示奖品价值）</el-radio
              >
            </el-form-item>
            <el-form-item label="积分价格题色：">
              <div class="color-item">
                <el-color-picker
                  v-model="formSave.pointPriceTextColor"
                ></el-color-picker>
                <jd-button
                  style="margin: 0 16px"
                  type="blueText"
                  @click="
                    formSave.pointPriceTextColor =
                      formSave.listStyle == 1 ? '#B76733' : '#E8D291'
                  "
                  >重置</jd-button
                >
              </div>
            </el-form-item>
            <el-form-item label="兑换按钮设置：">
              <div class="btn-setting">
                <div class="color-item">
                  按钮背景色：
                  <el-color-picker
                    v-model="formSave.buttonBgColor"
                  ></el-color-picker>
                  <jd-button
                    style="margin: 0 16px"
                    type="blueText"
                    @click="formSave.buttonBgColor = '#1E1E1F'"
                    >重置</jd-button
                  >
                </div>
                <div class="color-item" style="margin-top: 20px">
                  按钮文字色：
                  <el-color-picker
                    v-model="formSave.buttonTextColor"
                  ></el-color-picker>
                  <jd-button
                    style="margin: 0 16px"
                    type="blueText"
                    @click="formSave.buttonTextColor = '#ffffff'"
                    >重置</jd-button
                  >
                </div>
              </div>
            </el-form-item>
            <el-form-item label="自定义广告位：">
              <div class="ad-setting">
                <el-form-item label="广告标题：" label-width="100px">
                  <el-input
                    style="width: 320px"
                    v-model="formSave.adTitle"
                    placeholder="请输入标题"
                    maxlength="10"
                    show-word-limit
                  ></el-input>
                </el-form-item>
                <el-form-item label="上传图片：" label-width="100px">
                  <div class="flex-style">
                    <el-upload
                      style="
                        display: flex;
                        align-items: center;
                        margin-right: 16px;
                      "
                      action="/jd-hd-web/image/upload"
                      :before-upload="beforeUpload1"
                      :on-success="handleSuccess1"
                      :show-file-list="false"
                      accept=".png, .jpg"
                    >
                      <jd-button type="blue">自定义上传</jd-button>
                    </el-upload>
                    <span class="size-style">
                      尺寸建议：750*320px；支持格式：jpg，png
                    </span>
                  </div>
                  <div class="common-flex">
                    <div
                      v-for="(url, index) in adPicList"
                      :key="index"
                      class="img-style"
                    >
                      <img :src="url" alt class="url-style" />
                      <img
                        src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/preview/close.png"
                        alt=""
                        class="close-style"
                        @click="deleteHasSelect(index)"
                      />
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="跳转链接：" label-width="100px">
                  <el-input
                    style="width: 320px"
                    v-model="formSave.adLink"
                    placeholder="请输入http://开头的链接"
                  ></el-input>
                </el-form-item>
              </div>
            </el-form-item>
            <el-form-item label="赚积分任务入口：" v-if="isShowMoreActivity">
              <div>
                <el-radio v-model="formSave.showMoreActivity" :label="false"
                >不显示</el-radio
                >
                <el-radio v-model="formSave.showMoreActivity" :label="true"
                  >显示（C端活动页开启更多活动入口）</el-radio
                >
                <jd-button type="blueText" @click="goToEarnPointsTaskSetting">赚积分任务设置></jd-button>
              </div>
              <div class="flexc-cen-x" v-if="formSave.showMoreActivity">
                <el-upload
                  style="width: 44px;height: 55px;"
                  action="/jd-hd-web/image/upload"
                  ref="upload"
                  :limit="100"
                  :multiple="false"
                  :on-success="handleSuccessMoreActivityImg"
                  :show-file-list="false"
                  accept=".png, .jpg"
                >
                  <img
                    :src="formSave.moreActivityImg || 'https://cdn-image.yucrm.cn//hd/images/13315956_88c68b9823444d71a971e765b44bc056.png'"
                    style="width: 44px;height: 55px;"
                  />
                </el-upload>
                <jd-button @click="formSave.moreActivityImg = 'https://cdn-image.yucrm.cn//hd/images/13315956_88c68b9823444d71a971e765b44bc056.png'" type="blueText" style="margin-left: 16px;">重置</jd-button>
                <span style="color: #999999;font-size: 12px;margin-left: 16px;">尺寸建议：128*148px；支持格式：jpg，png</span>
              </div>
            </el-form-item>
          </el-form>
          <div class="footer">
            <jd-button
              label="保存设置"
              type="blue"
              @click="savePointSetting"
            ></jd-button>
            <jd-button
              label="重置"
              @click="handleReset"
            ></jd-button>
            <jd-button
              label="去添加积分兑换活动"
              @click="toGiftList"
            ></jd-button>
          </div>
        </div>
      </div>
      <div class="extension-content" v-else>
        <jd-title type="bold" label="积分商城推广"></jd-title>
        <div class="tips">请用手机京东扫描下面二维码查看您店铺的活动详情</div>
        <div class="qrcode-style">
          <qrcode-vue
            v-if="qrcodeVue.value"
            class="qrcode"
            :id="'qrcode'"
            :ref="'qrcode'"
            :size="qrcodeVue.size"
            :value="qrcodeVue.value"
            :bgColor="qrcodeVue.bgColor"
            :fgColor="qrcodeVue.fgColor"
            style="text-align: center;"
          >
          </qrcode-vue>
        </div>
        <p>链接地址：(手机京东店铺中活动详情链接地址)</p>
        <div class="copy-link">
          <el-tooltip
            class="item"
            effect="dark"
            :content="qrcodeVue.value"
            placement="top-start"
          >
            <div
              style="
                max-width: 400px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              "
            >
              {{ qrcodeVue.value }}
            </div>
          </el-tooltip>
          <jd-button
            type="blueText"
            style="margin-left: 12px"
            v-clipboard:copy="qrcodeVue.value"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
            >复制</jd-button
          >
          <jd-button
            type="blueText"
            style="margin-left: 12px"
            @click="handleSrcImg"
            >下载</jd-button
          >
        </div>
        <div class="footer-btn">
          <jd-button
            label="装修积分商城"
            type="blue"
            @click="isHasSave = false"
          ></jd-button>
          <jd-button
            label="去添加积分兑换活动"
            @click="toGiftList"
          ></jd-button>
        </div>
      </div>
    </div>
    <div class="decoration-right">
      <jd-title label="页面效果预览"></jd-title>
      <div style="margin-top: 20px">
        <phoneShow
          :formConfig="formSave"
          :list="pointExchangeActList"
        ></phoneShow>
      </div>
      <div class="moreActivityImg" v-if="formSave.showMoreActivity">
        <img
          :src="formSave.moreActivityImg || 'https://cdn-image.yucrm.cn//hd/images/13315956_88c68b9823444d71a971e765b44bc056.png'"
        />
      </div>
    </div>
  </div>
</template>
<script>
import qrcodeVue from "qrcode-vue";
import phoneShow from "./phoneShow.vue";
import { mapState } from "vuex";
import {
  exchangeActivityList,
  saveEchange,
  getDecorationInfoDetail,
} from "@/api/jhk/paradiseAndTaskCommonController.js";
export default {
  name: "",
  components: {
    qrcodeVue,
    phoneShow
  },
  props: {},
  data() {
    return {
      adPicList: [],
      // 限制图片上传格式
      extensions: [".jpg", ".png"],
      isHasSave: false,
      formSave: {
        awardImageUrl:
          "https://yunqi-hd-public.tos-cn-beijing.volces.com/image/pointExchangeBg.png",
        listStyle: 1,
        stockIsShow: false,
        awardValueIsShow: false,
        countdownIsShow: false,
        moreActivityIsShow: false,
        pointPriceTextColor: "#B76733",
        buttonBgColor: "#1E1E1F",
        buttonTextColor: "#ffffff",
        adTitle: "",
        adPic: "",
        adLink: "",
        showMoreActivity:false, // 赚积分任务入口
        moreActivityImg: "https://cdn-image.yucrm.cn//hd/images/13315956_88c68b9823444d71a971e765b44bc056.png"
      },
      cacheForm: {
        awardImageUrl:
          "https://yunqi-hd-public.tos-cn-beijing.volces.com/image/pointExchangeBg.png",
        listStyle: 1,
        stockIsShow: false,
        awardValueIsShow: false,
        countdownIsShow: false,
        moreActivityIsShow: false,
        pointPriceTextColor: "#B76733",
        buttonBgColor: "#1E1E1F",
        buttonTextColor: "#ffffff",
        adTitle: "",
        adPic: "",
        adLink: "",
        showMoreActivity: false,
        moreActivityImg: "https://cdn-image.yucrm.cn//hd/images/13315956_88c68b9823444d71a971e765b44bc056.png"
      },
      qrcodeVue: {
        size: 200,
        bgColor: "#fff",
        fgColor: "#000",
        value: "", //二维码地址
        logo: require("@/assets/new-images/jd_logo.svg"), //logo图片
      },
      pointExchangeActList: [],
    };
  },
  computed: {
    ...mapState(["loginUserInfo"]),
    isShowMoreActivity() {
      if (this.loginUserInfo && this.loginUserInfo.permissions) {
        const index = this.loginUserInfo.permissions.indexOf(
          "hide:platform:order:pointsTaskConfig"
        );
        console.log('isShowMoreActivity',index);
        if (index != -1) {
          return true;
        } else {
          return false;
        }
      }
    },
  },
  watch: {},
  mounted() {
    if(window.innerWidth < 1700) {
      this.qrcodeVue.size = 100
    }
    this.queryTemplate();
    setTimeout(()=> {
      console.log('333', this.qrcodeVue.size)
    }, 3000)
  },
  methods: {
    goToEarnPointsTaskSetting(){
      let routeUrl = this.$router.resolve({
        path: "/interactiveMarketing/earnPointsTasks"
      });
      window.open(routeUrl.href);
    },
    handleReset() {
      this.formSave = JSON.parse(JSON.stringify(this.cacheForm));
      this.adPicList = [];
    },
    deleteHasSelect(index) {
      this.adPicList.splice(index, 1);
      this.formSave.adPic = "";
    },
    getList() {
      let res = null;
      if (res.code == 1) {
        if (res.data.records.length > 0) {
          this.templateId = res.data.records[0].id;
          this.formSave = JSON.parse(res.data.detailInfo);
          this.eduitApp = false;
          this.getQRurl();
        } else {
          this.qrcodeVue.value = "";
          this.templateId = "";
          this.formSave = JSON.parse(JSON.stringify(this.cacheForm));
          this.isHasSave = false;
        }
        let params = {
          size: 100,
          current: 1,
          activityType: 9,
        };
        let result = null;
        // let result = await getList(params);
        if (result.code == 200) {
          this.pointExchangeActList = result.data.records;
        }
      }
    },
    toGiftList() {
      this.$emit("returnStep");
    },
    queryTemplate() {
      getDecorationInfoDetail().then((res) => {
        if (res.code == 1) {
          if (res.data && res.data.id) {
            this.templateId = res.data.id;
            this.formSave = JSON.parse(res.data.detailInfo);
            this.adPicList = this.formSave.adPic ? [this.formSave.adPic] : [];
            this.isHasSave = true;
            let xcxUrl = this.$commonUrl(); // 正式
            let params1 = `venderId%3D${res.data.venderId}`;
            this.qrcodeVue.value =
              xcxUrl +
              "pages/pointExchange/exchangeList/exchangeList.html%3f" +
              params1;
          } else {
            this.qrcodeVue.value = "";
            this.templateId = "";
            this.formSave = JSON.parse(JSON.stringify(this.cacheForm));
            this.isHasSave = false;
          }
          // 赚积分任务入口，默认值
          if(!this.formSave.showMoreActivity){
            this.$set(this.formSave,"showMoreActivity",false)
          }
          if(!this.formSave.moreActivityImg){
            this.$set(this.formSave,"moreActivityImg","https://cdn-image.yucrm.cn//hd/images/13315956_88c68b9823444d71a971e765b44bc056.png")
          }
        }
        let params = {
          current: 1,
          size: 100,
          isDisplay: 1,
        };
        exchangeActivityList(params).then((res) => {
          if (res.code == 1) {
            this.pointExchangeActList = res.data.records;
          }
        });
      });
    },
    savePointSetting() {
      if (
        !this.formSave.awardImageUrl ||
        !this.formSave.buttonBgColor ||
        !this.formSave.buttonTextColor
      ) {
        this.$message.warning("请先完善页面信息~");
        return;
      }
      let formData = {
        detailInfo: JSON.stringify(this.formSave),
      };
      saveEchange(formData)
        .then((res) => {
          if (res.code == 1) {
            this.isHasSave = true;
            this.queryTemplate();
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {
          this.$message.error(res.message);
        });
    },
    handleColor(val) {
      if (val == 1) {
        this.formSave.pointPriceTextColor = "#B76733";
      } else {
        this.formSave.pointPriceTextColor = "#E8D291";
      }
    },
    onCopy() {
      this.$message.success("复制成功");
    },
    onError() {
      this.$message.error("复制失败");
    },
    handleSrcImg() {
      // 获取要下载的图片
      let img = document.querySelector(`#qrcode img`);
      // 获取图片地址
      let url = img.src;
      // 创建一个a节点插入的document
      let a = document.createElement("a");
      // 模拟鼠标click点击事件
      let event = new MouseEvent("click");
      // 设置a节点的download属性值
      a.download = "imgQR";
      // 将图片的src赋值给a节点的href
      a.href = url;
      // 触发鼠标点击事件
      a.dispatchEvent(event);
    },
    handleSuccessMoreActivityImg(res){
      console.log(res);
      if(res.code == 1){
        this.$set(this.formSave,"moreActivityImg",res.data)
      }else{
        this.$message.error(res.message)
      }
    },
    handleSuccess(res, file) {
      if (res && res.code == 1) {
        this.$message.success("上传图片成功");
        this.formSave.awardImageUrl = res.data;
      }
    },
    handleSuccess1(res, file) {
      if (res && res.code == 1) {
        this.$message.success("上传图片成功");
        this.formSave.adPic = res.data;
        this.adPicList = [this.formSave.adPic];
      }
    },
    beforeUpload(file) {
      let fileExtensions = this.extensions.some((ext) =>
        file.name.toLowerCase().endsWith(ext)
      );
      if (!fileExtensions) {
        this.$message.error("图片格式错误");
        this.$refs.upload.clearFiles();
        return;
      }
    },
    beforeUpload1(file) {
      let fileExtensions = this.extensions.some((ext) =>
        file.name.toLowerCase().endsWith(ext)
      );
      if (!fileExtensions) {
        this.$message.error("图片格式错误");
        this.$refs.upload1.clearFiles();
        return;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  display: flex;
  flex-wrap: nowrap;
  font-family: PingFang SC, PingFang SC;
  height: 100%;
  .integral {
    min-width: 730px;
    width: calc(100% - 432px);
    // height: calc(100vh - 100px);
    background: #fff;
    margin-right: 16px;
    padding: 20px;
    border-radius: 8px;
    box-sizing: border-box;
    overflow-y: scroll;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      width: 0 !important;
    }
    -ms-overflow-style: none;
    .decor-content {
      margin-top: 20px;
      .content-form {
        margin-top: 26px;
        .btn-setting {
          width: 500px;
          background: #f8f9fc;
          padding: 22px 16px;
        }
        .ad-setting {
          width: 500px;
          background: #f8f9fc;
          padding: 22px 0;
          .common-flex {
            display: flex;
            align-items: center;
            flex-wrap: nowrap;
            .img-style {
              position: relative;
              width: 100px;
              height: 100px;
              margin-top: 16px;
              margin-right: 20px;
              border-radius: 4px;
              .url-style {
                width: 100%;
                height: 100%;
                border-radius: 4px;
              }
              .close-style {
                cursor: pointer;
                width: 24px;
                height: 24px;
                position: absolute;
                top: 0;
                right: 0;
              }
            }
            .img-style:not(:first-child) {
              margin-left: 20px;
            }
          }
        }
        .color-item {
          display: flex;
          align-items: center;
          color: #666666;
          font-size: 14px;
        }
        .size-style {
          display: flex;
          align-items: center;
          font-weight: 400;
          font-size: 12px;
          color: #999999;
          white-space: nowrap;
        }
        .flex-style {
          display: flex;
        }
      }
    }
    .extension-content {
      margin-top: 20px;
      .tips {
        margin: 20px 0;
      }
      .qrcode-style {
        margin-bottom: 20px;
        display: inline-block;
        // width: 200px;
        // height: 200px;
        // display: flex;
        // justify-content: center;
        // align-items: center;
        // flex-direction: column;
        img {
          width: 200px;
          height: 200px;
        }
      }
      .copy-link {
        margin-top: 20px;
        display: flex;
        align-items: center;
      }
      .footer-btn {
        margin-top: 20px;
      }
    }
  }
  .decoration-right {
    width: 416px;
    background: #ffffff;
    border-radius: 16px;
    height: calc(100vh - 100px);
    padding: 20px;
    overflow-y: auto;
    .moreActivityImg{
      width: 70px;
      height: 80px;
      position: absolute;
      right: 40px;
      bottom: calc(100vh - 800px);
      img{
        width: 100%;
        height: 100%;
      }
   }
  }
}
</style>
